<template>
  <div class="content menu-manage">
    <h3 ref="pageHeader" class="pageHeader">公共菜单管理</h3>

    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="handleAddParent">
        新增父菜单
      </el-button>
      <el-button icon="el-icon-refresh" @click="getList">刷新</el-button>
    </div>

    <div v-loading="loading" class="tree-panel">
      <el-tree ref="menuTree" :data="treeData" :props="treeProps" node-key="id" :expand-on-click-node="false"
        empty-text="暂无菜单数据">
        <span slot-scope="{ node, data }" class="custom-tree-node" :class="{ 'is-disabled': !!data.deleted_at }">
          <span class="node-content">
            <i v-if="data.icon" :class="data.icon" class="node-icon"></i>
            <span class="node-name" :title="node.label">{{ node.label }}</span>
            <span class="node-sort">
              <el-tag :type="isParentMenu(data) ? 'primary' : 'info'" size="mini" class="sort-label">
                {{ isParentMenu(data) ? '父' : '子' }}
              </el-tag>
              <el-input-number v-model="data.sort" :min="0" :max="9999" size="mini" :controls="false" :precision="0"
                class="sort-input" :title="isParentMenu(data) ? '父菜单排序' : '子菜单排序'"
                @change="handleSortChange(data)"></el-input-number>
            </span>
            <span class="node-index">
              <el-tag type="info" size="mini" v-if="data.deleted_at">已禁用</el-tag>
            </span>
          </span>
          <span class="node-actions">
            <el-button v-if="isParentMenu(data)" type="primary" size="mini"
              @click.stop="handleAddChild(data)">添加</el-button>
            <el-button  size="mini" @click.stop="handleEdit(data)">编辑</el-button>
            <el-button v-if="!data.deleted_at" type="warning" size="mini"
              @click.stop="handleDelete(data)">禁用</el-button>
            <el-button v-else type="success" size="mini"
              @click.stop="handleRecover(data)">启用</el-button>
            <el-button type="danger" size="mini" @click.stop="handleDestroy(data)">删除</el-button>
          </span>
        </span>
      </el-tree>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="720px"
      @closed="resetForm">
      <el-form ref="menuForm" :model="ruleForm" :rules="rules" label-width="100px">
        <el-form-item label="菜单名称" prop="title">
          <el-input v-model.trim="ruleForm.title" style="width:216px;" maxlength="50" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="icon">
          <el-input v-model.trim="ruleForm.icon" style="width:216px;" placeholder="例如：el-icon-s-order"></el-input>
        </el-form-item>
        <el-form-item label="菜单路径" prop="path">
          <el-input v-model.trim="ruleForm.path" style="width:216px;" placeholder="例如：/certificatesMine"></el-input>
        </el-form-item>
        <el-form-item label="菜单索引" prop="index">
          <el-input v-model.trim="ruleForm.index" style="width:216px;" ></el-input>
        </el-form-item>
        <template v-if="menuType === 'parent'">
          <el-form-item label="所属模块" prop="module">
            <el-select v-model="ruleForm.module" style="width:216px;" clearable placeholder="请选择所属模块">
              <el-option v-for="item in $store.state.defaultModules" :key="item.module" :label="item.label"
                :value="item.module"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="父级索引" prop="pindex">
            <el-input v-model.trim="ruleForm.pindex" style="width:216px;" disabled></el-input>
          </el-form-item>
        </template>

        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="ruleForm.sort" :min="0" style="width:216px;" :max="9999"
            controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item class="form-footer">
          <el-button type="primary" :loading="submitting" @click="submitForm">确定</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'menuManage',
  data() {
    return {
      loading: false,
      submitting: false,
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'title',
      },
      dialogVisible: false,
      dialogTitle: '新增父菜单',
      dialogType: 'add',
      menuType: 'parent',
      ruleForm: this.createEmptyForm(),
      rules: {
        title: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        icon: [{ required: true, message: '请输入菜单图标', trigger: 'blur' }],
        // path: [{ required: true, message: '请输入菜单路径', trigger: 'blur' }],
        index: [{ required: true, message: '菜单索引不能为空', trigger: 'blur' }],
        pindex: [{ required: true, message: '父级索引不能为空', trigger: 'blur' }],
        module: [{ required: true, message: '请选择所属模块', trigger: 'change' }],
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    createEmptyForm() {
      return {
        id: '',
        title: '',
        icon: 'el-icon-s-order',
        path: '',
        index: '',
        pindex: '',
        sort: 0,
        module: '',
      };
    },

    async getList() {
      this.loading = true;
      try {
        const res = await this.$api.instance.interfaceServer('api/menu/setting/list', 'get', {
          is_total: 1
        }, { isLoadd: false });
        if (res && res.code === 0) {
          this.treeData = this.normalizeTree(this.extractList(res.data));
        } else if (res) {
          this.$message.error(res.msg || '菜单列表加载失败');
        }
      } catch (error) {
        this.$message.error(error.message || '菜单列表加载失败');
      } finally {
        this.loading = false;
      }
    },

    extractList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (!data || typeof data !== 'object') {
        return [];
      }
      if (Array.isArray(data.data)) {
        return data.data;
      }
      if (Array.isArray(data.list)) {
        return data.list;
      }
      if (Array.isArray(data.records)) {
        return data.records;
      }
      return data.id || data.title ? [data] : [];
    },

    normalizeTree(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map((item) => {
        const children = Array.isArray(item.children)
          ? item.children
          : Array.isArray(item.childs)
            ? item.childs
            : Array.isArray(item.sub)
              ? item.sub
              : [];
        return {
          ...item,
          id: item.id === undefined || item.id === null ? '' : String(item.id),
          title: item.title || item.name || '',
          children: this.normalizeTree(children),
        };
      });
    },

    isParentMenu(data) {
      return !data.pindex;
    },

    async handleAddParent() {
      try {
        const res = await this.$api.instance.interfaceServer('api/menu/setting/maxIndex', 'get', {});
        if (!res || res.code !== 0) {
          this.$message.error((res && res.msg) || '获取最大菜单索引失败');
          return;
        }
        this.menuType = 'parent';
        this.dialogType = 'add';
        this.dialogTitle = '新增父菜单';
        this.ruleForm = this.createEmptyForm();
        this.ruleForm.index = this.getNextParentIndex(res.data);
        this.dialogVisible = true;
      } catch (error) {
        this.$message.error(error.message || '获取最大菜单索引失败');
      }
    },

    handleAddChild(data) {
      const pindex = String(data.index || '');
      if (!pindex) {
        this.$message.warning('当前菜单缺少父级索引，无法新增子菜单');
        return;
      }
      this.menuType = 'child';
      this.dialogType = 'add';
      this.dialogTitle = '新增子菜单';
      this.ruleForm = this.createEmptyForm();
      this.ruleForm.pindex = pindex;
      this.ruleForm.index = `${pindex}-${this.getNextChildIndex(data)}`;
      this.dialogVisible = true;
    },

    getNextParentIndex(maxIndexData) {
      const value = this.getIndexValue(maxIndexData);
      const maxIndex = Number.parseInt(value, 10);
      return String(Number.isNaN(maxIndex) ? this.getTreeMaxParentIndex() + 1 : maxIndex + 1);
    },

    getIndexValue(data) {
      if (typeof data === 'string' || typeof data === 'number') {
        return data;
      }
      if (!data || typeof data !== 'object') {
        return '';
      }
      return data.maxIndex || data.max_index || data.index || data.value || data.data || '';
    },

    getTreeMaxParentIndex() {
      return this.treeData.reduce((max, item) => {
        const index = Number.parseInt(item.index, 10);
        return Number.isNaN(index) ? max : Math.max(max, index);
      }, 0);
    },

    getNextChildIndex(parent) {
      const children = Array.isArray(parent.children) ? parent.children : [];
      const maxIndex = children.reduce((max, item) => {
        const parts = String(item.index || '').split('-');
        const index = Number.parseInt(parts[parts.length - 1], 10);
        return Number.isNaN(index) ? max : Math.max(max, index);
      }, 0);
      return maxIndex + 1;
    },

    handleEdit(data) {
      this.menuType = this.isParentMenu(data) ? 'parent' : 'child';
      this.dialogType = 'edit';
      this.dialogTitle = this.menuType === 'parent' ? '编辑父菜单' : '编辑子菜单';
      this.ruleForm = {
        ...this.createEmptyForm(),
        ...data,
        id: data.id,
        sort: data.sort === undefined || data.sort === null ? 0 : data.sort,
      };
      this.dialogVisible = true;
    },

    async submitForm() {
      this.$refs.menuForm.validate(async (valid) => {
        if (!valid || this.submitting) {
          return;
        }
        this.submitting = true;
        try {
          const params = {
            title: this.ruleForm.title,
            icon: this.ruleForm.icon,
            index: this.ruleForm.index,
            sort: this.ruleForm.sort,
            module: this.ruleForm.module,
            path: this.ruleForm.path,
            pindex: this.ruleForm.pindex? this.ruleForm.pindex : '',
          }
          if (this.dialogType === 'edit') {
            params.id = this.ruleForm.id;
          }
          const url = this.dialogType === 'add'
            ? 'api/menu/setting/create'
            : 'api/menu/setting/update';
          const res = await this.$api.instance.interfaceServer(url, 'post', params);
          if (res && res.code === 0) {
            this.$message.success(this.dialogType === 'add' ? '新增成功' : '编辑成功');
            this.dialogVisible = false;
            await this.getList();
            this.refreshStoreMenu();
          } else if (res) {
            this.$message.error(res.msg || '操作失败');
          }
        } catch (error) {
          this.$message.error(error.message || '操作失败');
        } finally {
          this.submitting = false;
        }
      });
    },
    async handleRecover(data) {
      try {
        await this.$confirm(`确认启用“${data.title}”吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (error) {
        return;
      }
      try {
        const res = await this.$api.instance.interfaceServer(
          'api/menu/setting/recover',
          'post',
          { id: data.id }
        );
        if (res && res.code === 0) {
          this.$message.success('启用成功');
          await this.getList();
          this.refreshStoreMenu();
        } else if (res) {
          this.$message.error(res.msg || '启用失败');
        }
      } catch (error) {
        this.$message.error(error.message || '启用失败');
      }
    },

    async handleDelete(data) {
      try {
        await this.$confirm(`确认禁用“${data.title}”吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (error) {
        return;
      }
      try {
        const res = await this.$api.instance.interfaceServer(
          'api/menu/setting/delete',
          'delete',
          { id: data.id }
        );
        if (res && res.code === 0) {
          this.$message.success('禁用成功');
          await this.getList();
          this.refreshStoreMenu();
        } else if (res) {
          this.$message.error(res.msg || '禁用失败');
        }
      } catch (error) {
        this.$message.error(error.message || '禁用失败');
      }
    },

    async handleDestroy(data) {
      try {
        await this.$confirm(`确认彻底删除“${data.title}”吗？该操作不可恢复！`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (error) {
        return;
      }
      try {
        const res = await this.$api.instance.interfaceServer(
          'api/menu/setting/destroy',
          'delete',
          { id: data.id }
        );
        if (res && res.code === 0) {
          this.$message.success('彻底删除成功');
          await this.getList();
          this.refreshStoreMenu();
        } else if (res) {
          this.$message.error(res.msg || '彻底删除失败');
        }
      } catch (error) {
        this.$message.error(error.message || '彻底删除失败');
      }
    },

    async handleSortChange(data) {
      const sort = Number(data.sort);
      if (!Number.isInteger(sort) || sort < 0) {
        this.$message.warning('排序必须为不小于 0 的整数');
        await this.getList();
        return;
      }
      const params = { id: data.id, sort };
      const keys = this.isParentMenu(data)
        ? ['title', 'icon', 'index', 'module']
        : ['title', 'icon', 'path', 'index', 'pindex'];
      keys.forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          params[key] = data[key];
        }
      });
      try {
        const res = await this.$api.instance.interfaceServer('api/menu/setting/update', 'post', params);
        if (res && res.code === 0) {
          this.$message.success('排序更新成功');
          this.refreshStoreMenu();
        } else {
          this.$message.error((res && res.msg) || '排序更新失败');
          await this.getList();
        }
      } catch (error) {
        this.$message.error(error.message || '排序更新失败');
        await this.getList();
      }
    },

    resetForm() {
      if (this.$refs.menuForm) {
        this.$refs.menuForm.resetFields();
      }
    },

    refreshStoreMenu() {
      // 菜单变更后同步更新 store 中的 menuItems（公共菜单数据，强制重新拉取接口）
      this.$store.dispatch('getMenuItems', { force: true });
    },
  },
};
</script>

<style lang="less" scoped>
.pageHeader:before {
  width: 132px;
}

.toolbar {
  margin-bottom: 16px;
}

.tree-panel {
  min-height: 280px;
  padding: 20px;
  background: #fff;
}

.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 34px;
  padding-right: 8px;
  border-bottom: 1px dashed #dcdfe6;
}

.custom-tree-node.is-disabled {
  background: #f5f5f5;
}

.custom-tree-node.is-disabled .node-name {
  font-style: italic;
  color: #909399;
}

.custom-tree-node.is-disabled .node-icon {
  color: #909399;
}

.node-content {
  display: flex;
  min-width: 0;
  align-items: center;
}

.node-icon {
  margin-right: 8px;
  color: #409eff;
}

.node-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.node-sort {
  display: flex;
  align-items: center;
  margin-left: 12px;

  .sort-label {
    flex: 0 0 auto;
    margin-right: 6px;
  }

  /deep/ .el-input-number.sort-input {
    width: 90px;
  }
}

.node-index {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.node-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 0px;
  margin-left: 16px;
  white-space: nowrap;
}

.form-footer {
  margin-top: 8px;
  text-align: right;
}

/deep/ .el-tree-node__content {
  height: auto;
  min-height: 40px;
}
</style>
